import { Permission } from '../constants';
import { Role } from '../constants/role';
import { HubBrief } from '../../store/state/administration/hub/models/hub.model';

export interface MenuItemModel {
  title: string;
  url?: string;
  icon?: string;
  permission?: Permission | string;
  requiredRole?: Role;
  featureFlagKey?: string;
  hubPropertyKey?: keyof HubBrief;
  children?: MenuItemModel[];
  externalUrl?: string;
}
